import type { LangCode, NewPlanDefault_EditPageQuery } from "@/lib/gql/__generated__/graphql";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import { NameOfResourceBeingEdited } from "@/components/features/_components";
import {
	FeatureIslandContainer,
	FeatureIslandHeader,
	FeatureIslandMainWithCategory,
} from "@/components/features/_layouts";

import { ProductNewPlanFormModelContextProvider } from "./context";
import { useInitialized } from "../../model/usecase/new/use-init";
import { PlanFormMain } from "../_shared/components/root";
import { planCategoriesAndManagerStore } from "../_shared/store/categories";
import { HeaderActions } from "./components/header/actions";

type Props = {
	hotelID: string;
	planID: string | undefined;
	activeLangCode: LangCode;
	serverModel: NewPlanDefault_EditPageQuery;
};

export const NewPlanEditPresenter = ({ serverModel, activeLangCode }: Props) => {
	const init = useInitialized({
		serverModel,
	});

	const { categoryManagerStore } = planCategoriesAndManagerStore;

	const { isDirty } = init.viewModel;
	useTransitionBlock(isDirty);

	const planName = init.viewModel.name.value;

	return (
		<ProductNewPlanFormModelContextProvider value={{ ...init }}>
			<FeatureIslandContainer>
				<FeatureIslandHeader
					title="新しいプランの編集"
					activeLangCode={activeLangCode}
					rightChildren={<HeaderActions />}
				/>
				<FeatureIslandMainWithCategory categoryManagerStore={categoryManagerStore}>
					{/* @todo Layout の共通化が出来るまでは共通化しない */}
					<NameOfResourceBeingEdited resourceName={planName} />

					<PlanFormMain planCategoriesAndManagerStore={planCategoriesAndManagerStore} />
				</FeatureIslandMainWithCategory>
			</FeatureIslandContainer>
		</ProductNewPlanFormModelContextProvider>
	);
};

NewPlanEditPresenter.displayName = "NewPlanEditPresenter";
